import { render, staticRenderFns } from "./WeeklyStandup.vue?vue&type=template&id=5f89b0a8&scoped=true&"
import script from "./WeeklyStandup.vue?vue&type=script&lang=ts&"
export * from "./WeeklyStandup.vue?vue&type=script&lang=ts&"
import style0 from "./WeeklyStandup.vue?vue&type=style&index=0&id=5f89b0a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89b0a8",
  null
  
)

export default component.exports